export const VARIANT_COLOR = 'teal'

export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

export const GEOSERVER_URL = process.env.REACT_APP_GEOSERVER_URL
export const GEOSERVER_WMTS_LAYER = process.env.REACT_APP_GEOSERVER_WMTS_LAYER
export const GEOSERVER_WMS_LAYER = process.env.REACT_APP_GEOSERVER_WMS_LAYER

export const WMTS_URL = `${GEOSERVER_URL}/gwc/service/wmts?service=wmts&version=1.1.0&request=GetCapabilities&layer=${GEOSERVER_WMTS_LAYER}`
export const WMS_URL = `${GEOSERVER_URL}/${GEOSERVER_WMS_LAYER}/wms`

export const baseUrl = process.env.NODE_ENV === "development" ? "https://geoses.radar.geod.bme.hu" : "https://geoses.radar.geod.bme.hu"
